var React = require('react');
import { Link } from 'react-router-dom';
import { USE_HOSTNAME } from './constants';
import { LoginUser } from './utils'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

class Profile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Profile: {
				FirstName: "FirstName",
                LastName: "LastName",
                Email: "Email",
                Password: "",
                ConfirmPassword:""
        	},
            isToggleOn: true,

        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEditChange = this.handleEditChange.bind(this);
        
       fetch('/api/Profile', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					this.setState({
						Profile: json[0]
					})
				});
    }

    componentDidMount() {
        
    }

    handleChange() {
        this.setState(prevState => ({
            isToggleOn: false
        }));
    }
    
    handleEditChange(e) {
        this.setState(prevState => ({ 
			Profile: {
				...prevState.Profile,
				[e.target.id]: e.target.value 
			}
		}));
    }

    handleSubmit() {
        event.preventDefault();
        if(this.state.Profile.Password===this.state.Profile.ConfirmPassword){
			this.UpdatePassword(this.state.Profile.Password);
		}else{
			alert("Passwords does not match");
		}
        
    }
    
    UpdatePassword(password) {
	    fetch("api/User/Password", {
	        method: 'PATCH',
	        headers: { 'Content-Type': 'application/json' },
	        body: JSON.stringify({
	            "Password": password
	        })
	    }).then((response) => {
	        if (response.ok) {
				alert("Password updated successfully");
	            window.location.hash = '#/Profile';
	            window.location.reload();
	            return response.json();
	        }
	        return response.json().then((body) => {
	            throw new Error(body.error);
	        })
	    })
	    .catch((error) => {
	        alert(error.message);
	    });
}

    render() {
        return (
            <Box component="form" noValidate autoComplete='off'>
                <div className="DivProfile">
                    <Box sx={{ mt: 10 }}>
                        <Typography variant="h4"> Profile </Typography>
                        <TextField id="firstname" label="FirstName" value={this.state.Profile.FirstName} InputProps={{ readOnly: true, }} />
                        <TextField id="lastname" label="LastName" value={this.state.Profile.LastName} InputProps={{ readOnly: true, }} />
                        <br /><br />
                        <TextField id="email" label="Beyondsoft Email" value={this.state.Profile.Email} InputProps={{ readOnly: true, }} />
                        <TextField type="password" id="Password" label="Password" value={this.state.Profile.Password} onChange={this.handleEditChange} InputProps={{ readOnly: this.state.isToggleOn, }}
                        disabled={this.state.isToggleOn}/>
                        <TextField type="password" id="ConfirmPassword" label="Confirm Password" value={this.state.Profile.ConfirmPassword} onChange={this.handleEditChange} InputProps={{ readOnly: this.state.isToggleOn, }}
                        disabled={this.state.isToggleOn}/>
                        <br /><br />
                        <Button variant="contained" onClick={this.handleChange}>New Password</Button>
                        <Button variant="contained" disabled={this.state.isToggleOn} onClick={this.handleSubmit}>Submit</Button>
                    </Box>
                </div>
            </Box>
        )
    };
};

export default Profile;